import React from 'react';

import { IProductTemplateAttribute } from 'components/dashboard/product-template-table/utils/interfaces';
import { InputSwitch, InputSwitchChangeParams } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'react-tooltip';

type DatetimeAndInstantTypesProps = {
	attribute: IProductTemplateAttribute;
	onAttrChangeInDatetimeAndInstant: React.Dispatch<
		React.SetStateAction<IProductTemplateAttribute>
	>;
};

const DatetimeAndInstantTypes: React.FC<DatetimeAndInstantTypesProps> = ({
	attribute,
	onAttrChangeInDatetimeAndInstant,
}) => {
	const onFieldChange = (
		e: React.ChangeEvent<HTMLInputElement> | InputSwitchChangeParams,
	) =>
		onAttrChangeInDatetimeAndInstant(prev => ({
			...prev,
			[e.target.name]: e.target.value,
		}));

	return (
		<>
			<div className='p-field p-col-6'>
				<label>Date display pattern</label>
				<InputText
					placeholder='e.g.: yyyy-MM-dd'
					value={attribute.dateDisplayPattern}
					name='dateDisplayPattern'
					onChange={onFieldChange}
					className='p-inputtext-sm'
				/>
			</div>
			<div className='flex-1 flex w-full align-self-center justify-content-center gap-3'>
				<Tooltip id='autoFillTime-tooltip' />
				<label
					htmlFor='autoFillTime'
					data-tooltip-id='autoFillTime-tooltip'
					data-tooltip-content='Auto fill date and/or time with current datetime on entry creation'>
					Auto fill time
				</label>
				<InputSwitch
					id='autoFillTime'
					checked={attribute.autoFillTime ?? false}
					name='autoFillTime'
					onChange={onFieldChange}
					className='p-inputtext-sm'
				/>
			</div>
		</>
	);
};

export default DatetimeAndInstantTypes;
